module.exports = __webpack_public_path__ + "static/img/dayoff.fcee59eb.svg";